var _path, _path2, _circle, _path3, _path4, _circle2, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.464 9.535a5 5 0 107.072-7.07 5 5 0 00-7.072 7.07z",
    fill: "#FFE300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.464 2.464a5 5 0 000 7.071l7.072-7.07a5 5 0 00-7.072 0z",
    fill: "#FFFC80"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 4.75,
    transform: "rotate(45 6 6)",
    stroke: "#FFE300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.464 9.464a5 5 0 107.072-7.071 5 5 0 00-7.072 7.071z",
    fill: "#FFE300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.464 2.393a5 5 0 000 7.071l7.072-7.071a5 5 0 00-7.072 0z",
    fill: "#FFFC80"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 5.928,
    r: 4.75,
    transform: "rotate(45 6 5.928)",
    stroke: "#FFE300"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.531 5.238a.178.178 0 00-.144-.121l-1.512-.22-.676-1.37a.178.178 0 00-.32 0l-.676 1.37-1.512.22a.178.178 0 00-.097.303l1.094 1.067-.264 1.507a.178.178 0 00.258.186l1.352-.71 1.353.71a.178.178 0 00.264-.186l-.258-1.506L8.487 5.42a.178.178 0 00.044-.183z",
    fill: "#2C3137"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Small_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Small_svg__clip1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 -.071)",
    d: "M0 0h12v12H0z"
  })))));
}
export default SvgSmall;